import { Component, Inject, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { AppService } from 'src/app/app.service';
import { LoaderService } from 'src/app/core/header-menu/loader/loader.service';
import { Product } from 'src/app/models/interface/product/product';
import { FtthService } from 'src/app/services/api/ftth/ftth.service';
import { NotificationLevel, NotificationsService } from 'src/app/services/api/notifications/notifications.service';
import { ProductDepthLevelCfsActionsComponent } from '../product-depth-level-cfs-actions.component';
import { isNullOrUndefined } from 'util';

@Component({
  selector: 'app-change-ont-password',
  templateUrl: './change-ont-password.component.html',
  styleUrls: ['./change-ont-password.component.scss']
})
export class ChangeOntPasswordComponent implements OnInit {

  changeOntPasswordGroup: FormGroup;

  loading: boolean;

  private item: Product;
  private subscriptions = new Subscription();

  constructor(
    private ftthService: FtthService,
    private loaderService: LoaderService,
    private notificationsService: NotificationsService,
    private translateService: TranslateService,
    private formBuilder: FormBuilder,
    private dialogRef: MatDialogRef<ProductDepthLevelCfsActionsComponent>,
    private appService: AppService,
    @Inject(MAT_DIALOG_DATA) private data: {
      item: Product;
      serviceId: number;
      type: string;
      ontPassword: string;
    },
  ) {
  }

  ngOnInit() {
    this.item = this.data.item;

    if (this.data.type !== 'cfs') {
      throw new Error('It must be a CFS');
    }

    this.subscriptions.add(this.loaderService.loading$.subscribe(loading => this.loading = loading));

    this.initForm();
    this.initFormValues();
  }

  static noWhitespace(control: AbstractControl): ValidationErrors | null {
    if (control.value && /\s/.test(control.value)) {
      return { noWhitespace: true };
    }
    return null;
  }

  private initForm(): void {
    this.changeOntPasswordGroup = this.formBuilder.group({
      ontPasswordCodeNew: this.formBuilder.control({ value: '', disabled: false }, [Validators.required, Validators.maxLength(14), ChangeOntPasswordComponent.noWhitespace]),
      ontPasswordCode: this.formBuilder.control({ value: '', disabled: true }, Validators.required),
      serviceId: this.formBuilder.control({ value: '', disabled: true }, Validators.required),
    });
  }

  private initFormValues(): void {
    this.serviceIdControl.setValue(this.data.serviceId)
    this.ontPasswordCodeControl.setValue(this.data.ontPassword)
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }



  changeOntPassword(): void {
    if (this.changeOntPasswordGroup.valid) {
      let territoryUser: string = this.item.origin;
      if (isNullOrUndefined(territoryUser) || territoryUser === '') {
        territoryUser = this.item.cfses[0].cfsCharValues.find(productCharValue => productCharValue.specId === 'sc_ftth_territory_user') ?
          this.item.productCharValues.find(productCharValue => productCharValue.specId === 'sc_ftth_territory_user').value : this.appService.settings.portalOwner;
      }
      this.subscriptions.add(this.ftthService
        .changeOntPassword(
          this.ontPasswordCodeNewControl.value,
          this.serviceIdControl.value,
          territoryUser
        )
        .subscribe(
          () => {
            this.dialogRef.close(true);
            this.notificationsService.showNotification(this.translateService.instant('CHANGE_ONT_PASSWORD.success'), NotificationLevel.SUCCESS);
          },
          error => {
            this.notificationsService.showNotification(this.translateService.instant('CHANGE_ONT_PASSWORD.error'), NotificationLevel.ERROR);
          }));
    }
  }



  get serviceIdControl(): FormControl {
    return this.changeOntPasswordGroup.get('serviceId') as FormControl;
  }

  get ontPasswordCodeNewControl(): FormControl {
    return this.changeOntPasswordGroup.get('ontPasswordCodeNew') as FormControl;
  }

  get ontPasswordCodeControl(): FormControl {
    return this.changeOntPasswordGroup.get('ontPasswordCode') as FormControl;
  }

}
